export default "__VITE_ASSET__DzZ7EHCN__"